import Vue from 'vue';
import Library from '@app/global/icons';
import { faFileAlt, faFilePdf, faFileWord, faFileExcel, faFileImage, faFileArchive } from '@fortawesome/pro-light-svg-icons';
Library.add(faFileAlt, faFilePdf, faFileWord, faFileExcel, faFileImage, faFileArchive);
export default Vue.extend({
    props: {
        block: Object
    },
    methods: {
        getIconForFileType: function (media) {
            if (media.type == 'image') {
                return 'file-image';
            }
            else if (media.type == 'application' && media.extension == 'pdf') {
                return 'file-pdf';
            }
            else if (media.type == 'application' && ['zip', 'rar', 'gzip', 'tar'].includes(media.extension)) {
                return 'file-archive';
            }
            else if (media.type == 'application' && ['doc', 'docx', 'pages'].includes(media.extension)) {
                return 'file-word';
            }
            else if (media.type == 'application' && ['xls', 'xlsx', 'csv'].includes(media.extension)) {
                return 'file-excel';
            }
            return 'file-alt';
        }
    }
});
